/*
 CookiesFooter
  
 historia: 
  PM 2021-10-29 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Box, Button, Container, Theme, Typography } from '@material-ui/core';

interface CookiesFooterState {
    open: boolean,
}

class CookiesFooter extends React.Component<WithStyles<typeof styles>, CookiesFooterState> {

    constructor(props: WithStyles<typeof styles>) {
        super(props);
        this.state = {
            open: true
        };
    }

    onAccept = () => {
        localStorage.setItem('cookies_zaakceptowane', "true");
        this.setState({ open: false })
    }

    backgroundColor = (theme: Theme) => theme.palette.grey[200]

    //PM 2021-11-03
    //https://github.com/mui-org/material-ui/tree/master/docs/src/pages/getting-started/templates/sticky-footer
    render() {
        const { classes } = this.props;

        return (
            <Box
                component="footer"
                sx={{
                    py: 3,
                    px: 2,
                    mt: 'auto',
                }}
                className={classes.box}
                style={{ display: this.state.open ? '' : 'none' }}
            >
                <Container maxWidth='xl'>
                    <Typography
                        variant="body1"
                        className={classes.typography}
                        style={window.innerWidth > 600 ? { margin: 0, position: 'absolute', top: '50%', transform: 'translate(0, -50%)' } : {}}
                    >
                        {'Strona używa plików cookies w celu realizacji usług i zgodnie z '}
                        <a href="https://vsc24.net/vscZasady/zasady/Cookies/Standard" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.button}`}
                            >
                                Polityką Plików Cookies.
                            </Button>
                        </a>
                    </Typography>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.onAccept}
                        className={classes.acceptButton}
                    >
                        <b>ok, akceptuję</b>
                    </Button>
                </Container>
            </Box>
        );
    }
}

const styles = (theme: Theme) => ({
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    button: {
        padding: 0,
        fontSize: '12px',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    box: {
        position: 'fixed' as 'fixed',
        bottom: '0',
        width: 'calc(100% - 32px)',
        padding: '12px 16px',
        borderTop: `1px solid ${theme.palette.primary.dark}`,
        background: 'white'
    },
    link: {
        textDecoration: 'none',
    },
    typography: {
        float: 'left' as 'left',
        fontSize: '12px'
    },
    acceptButton: {
        float: 'right' as 'right',
        textTransform: 'none' as 'none'
    }
});

export default withStyles(styles)(CookiesFooter);
